import React from 'react'
import styled from 'styled-components'
import { Link, Head } from 'react-static'

import AboutGatAmpSVG from './AboutGatAmpSVG'
import AboutBGSVG from './AboutBGSVG'
import BackArrow from '../../common/BackArrow'
import Reveal from '../../common/Reveal'

import steps from '../../../images/zebra2.jpg'

const Wrapper = styled.div`
  position: relative;
  background-color: #f3f3f3;
  background: url(${steps}) repeat;
  overflow: hidden;
  padding: 4em 25px;
  color: ${props => props.theme.main.bg};
  min-height: 100vh;

  .about-title {
    text-align: center;


    h2 {
      color: #fff;
      display: block;
      margin: 1em auto -3em;
      font-size: 1.8em;
      padding-top: 1.84em;
      height: 5em;
      width: 5em;
      background-color: ${props => props.theme.secondary.bg2};
      border-radius: 100%;
      text-shadow: 3px 3px 0 ${props => props.theme.secondary.bg};
    }
  }

  .back-arrow {
    position: absolute;
    top: 25px;
    right: 25px;
    width: 3.5em;
    padding: 0.5em;
    display: block;
    z-index: 5;

    img {
      width: 100%;
    }
  }

  .about-text {
    max-width: 37em;
    margin: 3em auto 0;

    a {
      text-decoration: underline;
      font-weight: bold;
      color: ${props => props.theme.main.bg};
    }

    span {
      color: ${props => props.theme.secondary.bg3};
      font-size: 1.4em;
      display: inline-block;
      margin-right: 0.1em;
    }
  }

  svg.about-gat-amp {
    max-width: 27em;
  }

  svg.about-bg-svg {
    display: none;
  }

  @media screen and (min-width: 1200px) {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .about-content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      position: relative;
      z-index: 2;
    }

    svg.about-gat-amp {
      max-width: 33em;
    }

    svg.about-bg-svg {
      display: block;
    }

    .svg-wrapper {
      width: 50%;
      padding-right: 3em;
    }

    .about-text-wrapper {
      width: 50%;
    }

    .about-text {
      margin-top: 0;
    }
  }
`

const About = () => (
  <Wrapper>
    <Head>
      <title>About</title>
      <meta name="description" content="Bagnall Hill Recording Studio is an independent recording studio located in Te Pahu, a small rural settlement south west of Hamilton, New Zealand."/>
    </Head>
    <BackArrow />
    <div className="about-content">
      <Reveal className="svg-wrapper">
        <AboutGatAmpSVG />
      </Reveal>
      <Reveal className="about-text-wrapper">
        <div className="about-text">
          <p><span>Bagnall Hill</span> is an independent recording studio located in Te Pahu, a small rural settlement south west of Hamilton, New Zealand. Over the years the studio has seen a host of local and international talent come through for recording, writing, showcase performances, rehearsals and releases.</p>
          <p>Once a storage shed for a trucking company, the building has been rebuilt as a spacious, natural-sounding studio and houses an impressive collection of recording equipment and instruments. Take a look at the growing arsenal of gear <Link to="/gallery">here</Link>.</p>
        </div>
      </Reveal>
    </div>
    <AboutBGSVG />
  </Wrapper>
)

export default About



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/about/About.js